// src/components/Navbar.js
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Badge,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  useMediaQuery
} from '@mui/material';
import {
  Menu as MenuIcon,
  ShoppingCart,
  Home,
  ListAlt as OrdersIcon,
  Login,
  Logout
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useCart } from '../CartContext';
import logo from '../assets/logo.png';

const Navbar = ({ isAuthenticated, setAuth }) => {
  const { cartItems } = useCart();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleLogout = () => {
    localStorage.removeItem('authenticated');
    setAuth(false);
  };
  const toggleDrawer = () => setDrawerOpen(open => !open);

  const drawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer}>
      <List>
        {isAuthenticated ? (
          <>
            <ListItem button component={Link} to="/">
              <ListItemIcon><Home /></ListItemIcon>
              <ListItemText primary="Menu" />
            </ListItem>
            <ListItem button component={Link} to="/past-orders">
              <ListItemIcon><OrdersIcon /></ListItemIcon>
              <ListItemText primary="Past Orders" />
            </ListItem>
            <ListItem button component={Link} to="/cart">
              <ListItemIcon>
                <Badge badgeContent={cartItems.length} color="error">
                  <ShoppingCart />
                </Badge>
              </ListItemIcon>
              <ListItemText primary="Cart" />
            </ListItem>
            <ListItem button onClick={handleLogout}>
              <ListItemIcon><Logout /></ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </>
        ) : (
          <ListItem button component={Link} to="/auth">
            <ListItemIcon><Login /></ListItemIcon>
            <ListItemText primary="Login/Signup" />
          </ListItem>
        )}
      </List>
    </Box>
  );

  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <img
          src={logo}
          alt="LA Catering"
          width={100}
          style={{ marginRight: 'auto' }}
        />

        {isMobile ? (
          <>
            <IconButton edge="end" color="inherit" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={toggleDrawer}
            >
              {drawerList}
            </Drawer>
          </>
        ) : (
          <>
            {isAuthenticated ? (
              <>
                <Button component={Link} to="/" color="secondary">
                  Menu
                </Button>
                <Button component={Link} to="/past-orders" color="secondary">
                  Past Orders
                </Button>
                <Button component={Link} to="/cart" color="secondary">
                  <Badge badgeContent={cartItems.length} color="error">
                    <ShoppingCart />
                  </Badge>
                </Button>
                <Button color="secondary" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <Button component={Link} to="/auth" color="secondary">
                Login/Signup
              </Button>
            )}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
